import { Button } from '@audio-network/componentlibrary/v2'
import { Container } from '@audio-network/componentlibrary'

import { LoadMoreProps } from './LoadMore.types'
import React from 'react'
import { useTranslation } from 'next-i18next'

const LoadMore = ({
	loading,
	onLoadMore,
	...props
}: LoadMoreProps): JSX.Element => {
	const { t } = useTranslation(['albums'])

	return (
		<div {...props}>
			<Container maxWidth="large">
				<Button spinner={loading} onClick={onLoadMore}>
					{t('load-more')}
				</Button>
			</Container>
		</div>
	)
}

export default LoadMore
